import { ActionListItemDescriptor, Autocomplete, Icon } from "@shopify/polaris";
import { DomainNewIcon, PlusCircleIcon, SearchIcon } from "@shopify/polaris-icons";
import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./AutocompleteSearch.module.css";

export type Section = {
    title: string;
    options: {
        value: string;
        label: string;
    }[];
};
interface ActionBeforeProps extends Partial<ActionListItemDescriptor> {}

interface Props {
    deselectedOptions: Section[];
    searchTerm: string;
    setSearchTerm: (val: string) => void;
    activeTab: {
        content: string;
        panelID: string;
        id: string;
        status: boolean;
        index: number;
    };
    actionBeforeProps?: ActionBeforeProps;
}

const AutocompleteSearch = ({ deselectedOptions, searchTerm, setSearchTerm, activeTab, actionBeforeProps }: Props) => {
    const [inputVal, setInputVal] = useState(searchTerm);
    const timeoutRef = useRef<any | null>(null);

    useEffect(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(() => {
            setSearchTerm(inputVal);
        }, 400);

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [inputVal]);

    const updateText = useCallback((value: string) => {
        setInputVal(value); // here only update local input
    }, []);

    useEffect(() => {
        setInputVal("");
        setSearchTerm("");
    }, [activeTab]);

    const updateSelection = useCallback(
        (selected: string[]) => {
            const selectedValue = selected[0];
            const match = deselectedOptions.flatMap((s) => s.options).find((o) => o.value === selectedValue);
            if (match) {
                setInputVal(match.label);
                setSearchTerm(match.label);
            }
        },
        [deselectedOptions, setSearchTerm],
    );

    const textField = (
        <Autocomplete.TextField
            onChange={updateText}
            label=""
            value={inputVal}
            prefix={<Icon source={SearchIcon} tone="base" />}
            placeholder={`Search in ${activeTab.content}...`}
            autoComplete="off"
            clearButton={true}
            onClearButtonClick={() => {
                setInputVal("");
                setSearchTerm("");
            }}
        />
    );

    return (
        <div className={styles.autocompleteSearch}>
            <Autocomplete
                textField={textField}
                selected={[]}
                {...(actionBeforeProps && activeTab?.id == "all" && !inputVal
                    ? { actionBefore: actionBeforeProps }
                    : {})}
                options={inputVal ? [] : deselectedOptions}
                onSelect={updateSelection}
            />
        </div>
    );
};

export default AutocompleteSearch;
